module.exports = __webpack_public_path__ + "img/w3_circle_up_grey.fac1ca0e.png";